import { ColumnDef, CustomTable } from "../../../common/table";
import {
  employeePathNames,
  pathNames,
  roleNames,
} from "../../../../constants/constants";
import { IEmployee } from ".";
import { useState } from "react";
import PersonInfo from "../../../common/person-info";
import { HistoryFieldEnum } from "../../../../types/common-types";
import BranchDepartmentInfo from "../../../common/branch-department";
import { useLocation, useNavigate } from "react-router-dom";
import {
  HistoryPayload,
  initialHistory,
} from "../../../../apis/history/history.api";
import HistoryModal from "../../../common/modal/HistoryModal";
import StatusCell from "../../../common/status-cell";

interface IEmployeeListProps {
  allEmployees: IEmployee[];
}

export default function AllEmployeeTable({ allEmployees }: IEmployeeListProps) {
  const navigate = useNavigate();
  const location = useLocation();
  // history states
  const [historyOpen, setHistoryOpen] = useState<boolean>(false);
  const [history, setHistory] = useState<HistoryPayload>(initialHistory);

  const handleOnClick = (row: IEmployee) => {
    if (
      location.pathname === pathNames.ALL_EMPLOYEE_PAY_SLIP ||
      location.pathname === employeePathNames.PAY_SLIP
    ) {
      navigate(`${pathNames.EMPLOYEE_PAY_SLIP_DETAILS}/${row?._id}`);
    } else {
      navigate(pathNames.EMPLOYEE_DETAILS, {
        state: {
          employeeId: row?._id,
        },
      });
    }
  };

  // Define configuration structures with isolated column custom components

  const columns: ColumnDef<IEmployee>[] = [
    {
      header: "#",
      className: "",
      render: (_, index) => index + 1,
    },
    {
      header: "Employee Name",
      className: "",
      render: (row) => (
        <PersonInfo
          personInfo={{
            profileImage: row?.profileImage,
            firstName: row?.firstName,
            lastName: row?.lastName,
            description: `${row.userId} | ${roleNames[row?.role]}`,
          }}
          onClick={() => handleOnClick(row)}
        />
      ),
    },
    {
      header: "Branch & Department",
      className: "",
      render: (row) => (
        <BranchDepartmentInfo
          branch={{ name: row.branchId?.name ?? "" }}
          shift={{
            name: row.shiftId?.name ?? "",
            startTime: row.shiftId?.startTime ?? "",
            endTime: row.shiftId?.endTime ?? "",
          }}
          department={{ name: row?.departmentId?.name ?? "" }}
        />
      ),
    },
    {
      header: "Status",
      className: "",
      render: (row) => {
        return (
          <StatusCell
            status={row.status}
            isEditable={false}
            onHistory={() => handleShowHistory(row)}
          />
        );
      },
    },
  ];

  // handle history open
  const handleHistoryOpenClose = () => {
    setHistoryOpen((prev) => !prev);
    setHistory(initialHistory);
  };

  // handle show history
  const handleShowHistory = (employee: IEmployee) => {
    handleHistoryOpenClose();
    setHistory({
      field: HistoryFieldEnum.UserStatus,
      fieldId: employee._id,
      title: `${employee.firstName} ${employee.lastName}`,
    });
  };

  return (
    <>
      <CustomTable columns={columns} data={allEmployees} />
      <HistoryModal
        isOpen={historyOpen}
        handleOpenClose={handleHistoryOpenClose}
        history={history}
      />
    </>
  );
}
